// DrawerProfile.js — En-tête du menu (drawer + version web) : profil + statut + compteurs en ligne.
// • Avatar + pseudo + badge niveau.
// • Statut choisissable : En ligne / Absent / Hors ligne (écrit dans les préférences → présence Nakama).
// • Compteurs : « X en ligne » (uniquement si ≥ min, sinon effet vide) + « Y amis en ligne » (toujours).
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../theme';
import { useAuth } from '../context/AuthContext';
import { usePresence } from '../context/PresenceContext';
import { getPrefs, savePrefs, loadPrefs, onPrefsChange } from '../services/preferences';
import { AvatarInner } from './HeroAvatar';
import LevelBadge from './LevelBadge';

const Box = styled.div`
  border: 1px solid ${theme.colors.border}; border-radius: 14px; padding: .8rem; margin-bottom: .6rem;
  background: ${theme.colors.bgCard};
`;
const Top = styled(Link)`
  display: flex; align-items: center; gap: .6rem; text-decoration: none; color: ${theme.colors.textPrimary};
  .av { width: 44px; height: 44px; border-radius: 50%; overflow: hidden; background: ${theme.colors.gradient};
    display: inline-flex; align-items: center; justify-content: center; color: #fff; font-weight: 800; flex-shrink: 0; }
  .id { min-width: 0; display: flex; flex-direction: column; align-items: flex-start; gap: 3px; }
  .n { font-weight: 800; font-size: .95rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%; }
`;
const Status = styled.div`
  display: flex; gap: .3rem; margin-top: .6rem;
  button { flex: 1; cursor: pointer; border-radius: 999px; padding: .3rem; font-size: .72rem; font-weight: 700;
    border: 1px solid ${theme.colors.border}; background: ${theme.colors.bgPrimary}; color: ${theme.colors.textSecondary}; }
  button.on { color: #fff; border-color: transparent; }
  button.online.on { background: #22c55e; } button.away.on { background: #f59e0b; } button.offline.on { background: #6b7280; }
`;
const Counts = styled.div`
  display: flex; gap: 1rem; margin-top: .6rem; font-size: .78rem; color: ${theme.colors.textSecondary};
  .c b { color: ${theme.colors.textPrimary}; } .dot { color: #22c55e; }
`;

const OPTS = [{ k: 'online', l: 'En ligne' }, { k: 'away', l: 'Absent' }, { k: 'offline', l: 'Hors ligne' }];

export default function DrawerProfile({ onNavigate }) {
  const { isLoggedIn, user } = useAuth();
  const { total, friendsTotal, min } = usePresence();
  const [status, setStatus] = useState('online');

  useEffect(() => { loadPrefs().then(() => setStatus(current())); }, []);
  useEffect(() => onPrefsChange(() => setStatus(current())), []);
  function current() { const p = getPrefs().privacy || {}; return p.showOnline === false ? 'offline' : (p.status || 'online'); }

  const pick = async (st) => {
    setStatus(st);
    const p = getPrefs();
    await savePrefs({ ...p, privacy: { ...p.privacy, status: st, showOnline: st !== 'offline' } });
  };

  if (!isLoggedIn) return null;
  const name = (user && (user.display_name || user.username)) || 'Toi';

  return (
    <Box>
      <Top to="/compte" onClick={onNavigate}>
        <span className="av"><AvatarInner url={user && user.avatar_url} name={name} size={44} /></span>
        <span className="id">
          <span className="n">{name}</span>
          {user && user.id && <LevelBadge userId={user.id} />}
        </span>
      </Top>
      <Status>
        {OPTS.map((o) => (
          <button key={o.k} className={`${o.k}${status === o.k ? ' on' : ''}`} onClick={() => pick(o.k)}>{o.l}</button>
        ))}
      </Status>
      <Counts>
        {total >= min && <span className="c"><span className="dot">●</span> <b>{total}</b> en ligne</span>}
        <span className="c">👥 <b>{friendsTotal || 0}</b> ami{(friendsTotal || 0) > 1 ? 's' : ''} en ligne</span>
      </Counts>
    </Box>
  );
}
